import { useEffect, useRef ,useState } from 'react';
import getUserStatus from '../services/getUserStatus';

const useSocketForReservationData = ({socket ,user_id ,reservation, onCloseReservation, setReservation, setCartStatus, handleCartAvailabilityDataFromServer ,connectionError }) => {
  
  const reconnectIntervalRef = useRef(null);
  const timeoutIntervalRef = useRef(null);


  const handleUserStatus =(userStatus) => {
     // get user status successfully
     if (
      typeof userStatus === 'object' &&
      userStatus.reservation !== undefined &&
      userStatus.cartStatus !== undefined
    ) {
      const cartAvailability = userStatus.cartAvailability;

      // Use functional updates to conditionally update state based on previous state
      setReservation(prevReservation => {
        if (prevReservation !== userStatus.reservation) {
          if(userStatus.reservation == null){
            console.log('Reservation closed');
            handleCartAvailabilityDataFromServer(cartAvailability);
            onCloseReservation();
          }
          return userStatus.reservation; 
        } else {
          if(prevReservation == null){
            // no reservation 
            handleCartAvailabilityDataFromServer(cartAvailability);

          }
          return prevReservation;
        }
      });
  
      setCartStatus(prevCartStatus => {
        if (prevCartStatus !== userStatus.cartStatus) {
          return userStatus.cartStatus;
        } else {
          return prevCartStatus; 
        }
      });
  
      // Update cart availability
      console.log("reservation updated " ,reservation);
      if (reservation == null) {
      
      }
    }
  }
  const getUserLiveStatus = async () => {
 
    // Fetch user status 
    const userStatus = await getUserStatus(user_id , connectionError);
    handleUserStatus(userStatus);
  }

  useEffect(() => {
    if(socket){
      function onConnect() {
        socket.emit('user_id', user_id);
        if(socket.recovered){
          getUserLiveStatus();
        }
      }
  
      function onDisconnect() {
      }
  
      const onCartStatusEvent =(p_cartStatus)=>{
        reservation && setCartStatus(p_cartStatus);
      }

      const onReservationStatusEvent =(p_reservationStatus)=>{
        if(!reservation) return;
        setReservation(p_reservationStatus);
      };


      const onCartAvailabilityEvent =(p_cartAvailability)=>{
        if (reservation == null) {
          handleCartAvailabilityDataFromServer(p_cartAvailability);
        }
      };
      
      const onUserInUseRelease =()=>{
        onCloseReservation();
      }

      socket.on('closeReservation', () => {
        onCloseReservation();
    });
    

      socket.on('connect', onConnect);
      socket.on('cartStatusToUser', onCartStatusEvent);
      socket.on('disconnect', onDisconnect);
      socket.on('reservationUpdate', onReservationStatusEvent);
      socket.on('cartsAvailability',onCartAvailabilityEvent);
      socket.on('userInUseRelease',onUserInUseRelease);
  
      return () => {
        socket.off('connect', onConnect);
        socket.off('disconnect', onDisconnect);
        socket.off('cartStatusToUser', onCartStatusEvent);
        socket.off('reservationUpdate', onReservationStatusEvent);
        socket.off('cartsAvailability',onCartAvailabilityEvent);
        socket.off('userInUseRelease',onUserInUseRelease);
        socket.off('closeReservation');
      };
    }
   
  }, [socket , reservation]);

  return null;
};

export default useSocketForReservationData;
